module.exports = __webpack_public_path__ + "img/SpimFashionLogo.0895cbc7.svg";